@for (fieldsBlock of fields; track fieldsBlock) {
	<div class="flex items-center relative flex-wrap pb-[20px]">
		@for (row of fieldsBlock.fields; track row; let block = $index) {
			<div class="ff-row-form overflow-x-hidden">
				@for (field of row; track field; let fieldPosition = $index) {
					@if (block === 0 && fieldPosition === 0 && data[field.entityKey]) {
						<div class="flex w-full">
							<div class="inline-flex items-center mb-[8px]">
								<p class="text-font text-xs mb-[15px]">{{ fieldsBlock.label }}</p>
							</div>
						</div>
					}
					@if (data[field.entityKey]) {
						<div class="ff-box-field ff-grid-field" [ngClass]="'ff-field-size-' + field.size">
							@if (field.type === 'HIDDEN') {
								<lbca-input-hidden
									[label]="field.label"
									[defaultValue]="field.defaultValue"
								></lbca-input-hidden>
							}
							@if (field.type === 'TEXT') {
								<lbca-input-text-condensed
									[label]="field.label"
									[tabeled]="false"
									[labeled]="false"
									[error]="field.error"
									[require]="field.required"
									[maskInput]="field.mask"
									[value]="data[field.entityKey] ? data[field.entityKey] : ''"
								></lbca-input-text-condensed>
							}
							@if (field.type === 'SELECT_ONE') {
								<lbca-entity-fields
									[forceType]="'SELECT_ONE_CONDENSED'"
									[cardData]="cardInfo"
									[field]="field"
									[label]="field.label"
									[error]="field.error"
									[tabeled]="false"
									[labeled]="false"
									[require]="field.required"
									[value]="data[field.entityKey] ? data[field.entityKey] : ''"
								></lbca-entity-fields>
							}
							@if (field.type === 'RADIO') {
								<lbca-entity-fields
									[forceType]="'SELECT_ONE_CONDENSED'"
									[field]="field"
									[cardData]="cardInfo"
									[inline]="true"
									[label]="field.label"
									[error]="field.error"
									[tabeled]="false"
									[labeled]="false"
									[require]="field.required"
									[value]="data[field.entityKey] ? data[field.entityKey] : ''"
								></lbca-entity-fields>
							}
							@if (field.type === 'CALENDAR') {
								<lbca-date-picker-condensed
									[label]="field.label"
									[tabeled]="false"
									[labeled]="false"
									[error]="field.error"
									[require]="field.required"
									[value]="data[field.entityKey] ? data[field.entityKey] : ''"
								></lbca-date-picker-condensed>
							}
							@if (field.type === 'DATE_TIME') {
								<lbca-date-time-picker-condensed
									[labelDate]="field.labelDate"
									[labelTime]="field.labelTime"
									[require]="field.required"
									[error]="field.error"
									[value]="data[field.entityKey] ? data[field.entityKey] : ''"
									[rules]="field.rules"
									[tabeled]="false"
									[labeled]="false"
								></lbca-date-time-picker-condensed>
							}
						</div>
					}
				}
			</div>
		}
	</div>
}
